<template>
  <div>
    <!-- 提示框 -->
    <transition name="el-zoom-in-top">
      <div
        class="tipBox"
        v-show="showTip"
        @click="showTip=!showTip"
      >
        <div
          class="tipCon"
          v-if="currentLanguage"
        >
          <img :src="tipStatus?'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/success-icon.png':'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/error-icon.png'">
          <h4>{{ tipStatus?'提交成功':'提交失败' }}</h4>
          <div
            class="text"
            v-if="tipStatus"
          > 
            感谢您关注浩顿！您的需求我们已经收到，稍后会有同事跟您联系！
          </div>
          <p v-else>
            请直接拨打底部电话和我们联系。
          </p>
        </div>
        <div
          class="tipCon"
          v-else
        >
          <img :src="tipStatus?'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/success-icon.png':'https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/error-icon.png'">
          <h4>{{ tipStatus?'success':'error' }}</h4>
          <div
            class="text"
            v-if="tipStatus"
          >
            <p>Thank you for submitting your request!</p>
            <p>A member from our team will be in touch with you shortly.</p>
          </div>
          <p v-else>
            Please call us directly at the bottom.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default{
    props:{
      tipStatus:{
           type: Boolean,
           default:false
      },
      showTip:{
           type: Boolean,
           default:false
      }
    },
    data(){
        return {
            
        }
    },
    computed: {
        currentLanguage(){
            return Number(this.$store.state.lang)
        }
    },
    methods:{

    }
}
</script>
<style lang="scss" scoped>

</style>
